<template>
  <box outline color="green" class="mb-1 dashboard-add-order" clickable @click="showAddOrder = true">
    <div class="dashboard-actions-item d-flex justify-stretch align-center">
      <div class="text-color-success"><span class="icon-plus dashboard-add-order__icon text--xxx-large rotate-90 d-inline-block"></span></div><div class="ml-2 text--medium">{{ $t('views.Dashboard.Orders.addOrder') }}</div>
    </div>

    <add-order @add="addOrder" :loading="isOrderAdding" v-model="showAddOrder" no-btn></add-order>
  </box>
</template>

<script>
import Box from '@/ui/slots/Box'

import AddOrder from '@/components/AddOrder'

import { AddOrderGQL } from '@/graphql/mutations'

import { notifyGraphqlError } from '@/mixins/handleGraphqlError'
import shouldReFetchOrders from '@/mixins/shouldReFetchOrders'

export default {
  name: 'dashboard-add-order',

  mixins: [notifyGraphqlError, shouldReFetchOrders],

  data () {
    return {
      showAddOrder: false,
      isOrderAdding: false
    }
  },

  methods: {
    async addOrder (order) {
      try {
        this.isOrderAdding = true
        await this.$apollo.mutate({
          mutation: AddOrderGQL,
          variables: {
            params: order
          }
        })

        this.isOrderAdding = false
        this.showAddOrder = false
        this.$notify({
          type: 'success',
          message: this.$i18n.t('views.Orders.orderAdded'),
          delay: 150,
          timeout: 3000
        })

        this.setShouldOrdersReFetch(true)
        await this.$apollo.queries.settlements.refetch()
      } catch (e) {
        this.isOrderAdding = false
        this.notifyGraphqlError(e)
      }
    }
  },

  components: {
    Box,

    AddOrder
  }
}
</script>

<style lang="scss">
.dashboard-add-order {
  &__icon {
    color: $color-success;
    padding: .2rem;
    border: 2px solid currentColor;
    border-radius: 50%;
  }
}
</style>
